import {useLocation} from 'react-router-dom';
import Permission from "./Permission";
import {ACCESS_TOKEN, RETRIEVE_IMAGE_URL} from "./APIURL";
import moment from "moment";

export const CLIENT_RESERVATION_BASE_URL = "https://reservestnd.com";

export const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

export const getParams = (query, data, callback, deps = []) => {

    for (const key of Object.keys(data)) {

        let value = query.get(key) || "";

        if (callback && value) {

            if (deps.includes(key)) {
                value = callback(value);
            }

        }

        data = {[key]: value, ...data}
    }

    return data;
}

export const isValueExistInSearch = (data) => {

    for (const key of Object.keys(data)) {
        if (data[key]) {
            return ["1"];
        }
    }
    return ["0"];
}

export const getBase64Image = (data) => {
    const base64 = btoa(
        new Uint8Array(data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            '',
        ),
    );

    return "data:;base64," + base64;
}

export const bindUrlWithParams = (url, params) => {
    let result = url;

    Object.keys(params).forEach(key => {
        if (!params[key]) {
            delete params[key];
        }
    });

    Object.keys(params).forEach((key, index) => {

        if (index === 0) {
            result += `?${key}=${params[key]}`;
        } else {
            result += `&${key}=${params[key]}`;
        }

    });

    return result;
}

export const getFullPreviousRoute = (history) => {
    return `${history.location.pathname}${history.location.search}`;
}

export const resetState = (data) => {
    for (const key of Object.keys(data)) {
        data = {...data, [key]: ""}
    }
    return data;
}

export const getAllNonObjectValues = (data) => {

    let singleValue = {};

    for (const [key, value] of Object.entries(data)) {
        if (typeof value !== "object") {
            singleValue[key] = value;
        }
    }
    return singleValue;
}

export const getAllNestedObjectValues = (data) => {
    let singleValue = [];

    for (const value of Object.values(data)) {
        if (value && typeof value === "object") {
            singleValue.push(value);
        }
    }
    return singleValue
}

export const getPercentageValue = (value, percent) => {
    return (value * percent) / 100;
}

export const hasPermission = (loggedInUserPermissions, permissions) => {

    if (!permissions) {
        return false;
    }

    if (permissions.includes(Permission.ALL)) {
        return true;
    }

    if (!loggedInUserPermissions) {
        return false;
    }

    for (const permission of permissions) {

        if (loggedInUserPermissions.includes(permission)) {
            return true;
        }

    }

    return false;
}

export const apiUserAuth = () => {
    return {
        Authorization: "Basic " + btoa("tigeruser:TigerPass")
    }
}

export const getAuthHeaders = () => {
    const accessToken = localStorage.getItem(ACCESS_TOKEN);
    return {"authorizationToken": `Bearer ${accessToken}`, "offset": new Date().getTimezoneOffset()};
}

export const getErrorMessage = error => {
    if (error.response) {
        if (error.response.data) {
            return error.response.data.message;
        }
        return error.response.data;
    } else {
        return error.message;
    }
}

export const DATE_FORMAT = "MM/DD/YYYY";
export const DATE_FORMAT1 = "MM-DD-YYYY";
export const TIME_FORMAT = "hh:mm A";
export const TIME_FORMAT1 = "HH:mm:ss";
export const TIME_FORMAT2 = "HH:mm";

export const dateTimeFormatterLocalFromUTC = date => {
    if (!date) return;
    return moment.utc(date, `${DATE_FORMAT1} ${TIME_FORMAT1}`).local().format(`${DATE_FORMAT} ${TIME_FORMAT}`);
}

export const dateTimeFormatter = date => {
    if (!date) return;
    return moment(date, `${DATE_FORMAT1} ${TIME_FORMAT1}`).format(`${DATE_FORMAT} ${TIME_FORMAT}`);
}

export const dateFormatter = date => {
    if (!date) return;
    return moment(date, `${DATE_FORMAT1} ${TIME_FORMAT1}`).format(DATE_FORMAT);
}

export const sendDateTimeFormatter = date => {
    if (!date) return null;
    return moment(date, `${DATE_FORMAT1} ${TIME_FORMAT1}`).format(`${DATE_FORMAT1} ${TIME_FORMAT1}`);
}

export const sendDateFormatter = date => {
    if (!date) return null;
    return moment(date, `${DATE_FORMAT1} ${TIME_FORMAT1}`).format(DATE_FORMAT1);
}

export const timeFormatter = time => {
    if (!time) return;
    return moment(time, TIME_FORMAT1).format(TIME_FORMAT);
}

export const timeFormatter1 = time => {
    if (!time) return;
    return moment(time, TIME_FORMAT1).format(TIME_FORMAT1);
}

export const timeFormatter2 = time => {
    if (!time) return;
    return moment(time, TIME_FORMAT).format(TIME_FORMAT1);
}

export const timeFormatterFromDateTime = (dateTime, minutes = 0) => {
    if (!dateTime) return;
    return moment(dateTime, `${DATE_FORMAT1} ${TIME_FORMAT1}`).add(minutes, "minutes").format(`${TIME_FORMAT}`);
}

export const timeFormatterFromDateTime1 = dateTime => {
    if (!dateTime) return;
    return moment(dateTime, `${DATE_FORMAT1} ${TIME_FORMAT1}`).format(`${TIME_FORMAT1}`);
}

export const fromDate = (day = 7) => moment(Date.now() - day * 24 * 3600 * 1000).set({
    "h": 0,
    "m": 0,
    "s": 0
}).format(DATE_FORMAT1);

export const toDate = () => moment(Date.now()).set({
    "h": 23,
    "m": 59,
    "s": 59
}).format(DATE_FORMAT1);

export const fromDate1 = (day = 7) => moment(Date.now() - day * 24 * 3600 * 1000).set({
    "h": 0,
    "m": 0,
    "s": 0
});

export const toDate1 = () => moment(Date.now()).set({
    "h": 23,
    "m": 59,
    "s": 59
});

export const getMaxTableKey = (tables) => {

    if (tables.length < 1) return 0;

    return Math.max(...tables.map(o => o.key));
}

export const enumFormatter = value => {
    if (!value) return;

    const words = value.toLowerCase().split("_");
    return words.map(value => value[0]
        .toUpperCase() + value.substring(1))
        .join(" ");
}

export const excelNameFormatter = (name, isDate) => {

    const date = moment.utc(moment(), "YYYY-MM-DD HH:mm:ss").local().format('D MMM YYYY hh:mm a');
    const formattedDate = date.split(" ").join("_");

    if (isDate) {
        return `${name}_${formattedDate}`
    } else {
        return name;
    }
}

export const getRetrieveImageUrl = (path) => {

    if (!path) return null;

    return `${RETRIEVE_IMAGE_URL}?path=${path}`;
};

export const phoneNumberFormat = (number) => {
    if (!number) return "";
    return `${number.slice(0, 2)}-${number.slice(2, 5)}-${number.slice(5, 8)}-${number.slice(8, number.length)}`;
}

export const phoneNumberInputFormat = (number) => {
    if (!number) return "";
    const newNumber = number.slice(2);
    return `${newNumber.slice(0, 3)}-${newNumber.slice(3, 6)}-${newNumber.slice(6, newNumber.length)}`;
}

export const phoneNumberValidator = (_, number, emptyAllowed) => {
    if (!number && emptyAllowed) return Promise.resolve();
    if (/(\d{3})-(\d{3})-(\d{4})/.test(number) && number?.length === 12) {
        return Promise.resolve();
    } else {
        return Promise.reject("Invalid Phone Number")
    }
}

export const phoneNumberPurifier = number => {
    if (!number) return;
    return number.replace(/-/g, "");
}

export const RADIAN = Math.PI / 180;
